import { styles } from '@/utils/config';
import { getYear } from 'date-fns';
import { Fragment } from 'react';
import { AttributionControl } from 'react-map-gl/maplibre';

export function MapBranding({ style }) {
  const selectedStyle = styles.find((s) => s.path === style) ?? styles[0];
  switch (selectedStyle.source) {
    case 'ORDNANCE_SURVEY':
      return (
        <Fragment>
          <AttributionControl
            key="os"
            customAttribution={`Contains OS data &copy; Crown copyright and database rights ${getYear(
              new Date(),
            )}`}
          />
          <a
            href="https://www.ordnancesurvey.co.uk"
            style={{
              position: 'absolute',
              left: 16,
              bottom: 40,
              zIndex: 999,
            }}
          >
            <img
              src="https://cdn11.bigcommerce.com/s-qc7qegnorm/stencil/f3596d30-6ad8-013e-a545-3e55c594ef69/e/aeae2230-fe86-0139-1f6d-3e31cf3a9a82/img/static/ordnance-survey.svg"
              alt="Ordnance Survey logo"
              height={16}
            />
          </a>
        </Fragment>
      );
    case 'MAPTILER':
      return (
        <a
          href="https://www.maptiler.com"
          style={{ position: 'absolute', left: 16, bottom: 40, zIndex: 999 }}
        >
          <img
            src="https://api.maptiler.com/resources/logo.svg"
            alt="MapTiler logo"
          />
        </a>
      );
    case 'OPENSTREETMAP':
      return (
        <a
          href="https://www.openstreetmap.org"
          style={{
            position: 'absolute',
            left: 16,
            bottom: 40,
            zIndex: 999,
          }}
        >
          <img
            src="https://www.openstreetmap.org/assets/osm_logo-4b074077c29e100f40ee64f5177886e36b570d4cc3ab10c7b263003d09642e3f.svg"
            alt="OpenStreetMap"
            style={{ width: 16, height: 16 }}
          />
        </a>
      );
    case 'PROTOMAPS':
      return (
        <a
          href="https://docs.protomaps.com"
          style={{
            position: 'absolute',
            left: 16,
            bottom: 40,
            zIndex: 999,
          }}
        >
          <img
            src="https://docs.protomaps.com/logo.svg"
            alt="ProtoMaps"
            style={{ width: 16, height: 16 }}
          />
        </a>
      );
    default:
      return null;
  }
}
